// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"App_appContainer__3I1d4","videoFeed":"App_videoFeed__33NMA"};